import {
	Breadcrumbs,
	Panel,
	PanelBody,
	PanelHeader
} from "@itandi/itandi-bb-ui";
import Link from "next/link";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { TodoTemplateList } from "~/components/common/todo_templates/TodoTemplateList";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { useSubtypes } from "~/hooks/useSubtypes";
import { PATH } from "~/pages/settings/subtypes";
import SettingStyles from "../../../SettingStyle.module.scss";

export function Page() {
	const id = useIdQueryHandler("subtypeId");
	const { data: subtype } = useSubtypes().useShow(id);

	if (subtype === null) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<div className={SettingStyles.BreadcrumbsBlock}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "案件タイプ設定" },
							{ label: "TODOテンプレート設定" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader title={`${subtype.name} TODOテンプレート設定`} />
					<PanelBody>
						<TodoTemplateList dealType="other" subtype={subtype} />
					</PanelBody>
				</Panel>
			</ClientSettingLayout>
		</DefaultV2>
	);
}
